var badgeData = {
  name: 'badge',
  data: [{
    bgColor: '#F13131',
    fontColor: '#fff',
    borderColor: '#F13131',
    fontSize: 12,
    height: 14,
    radius: 7,
    dotSize: 6,
    countTop: '-0.07rem'
  }]
};
export default badgeData;